export default __webpack_public_path__ + "static/media/property_1_5.ab3a643e.webp";